// extracted by mini-css-extract-plugin
export default {"paymentSection":"j7-z"};